
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
    "commitHash": "a5b3c864e1537d0fe0a7f8f0b55989ef89311fa2",
    "version": "17.3.0"
};
